import Accordion from 'components/Accordion';
import Checkbox from 'components/Form/Checkbox';
import Stacked from 'components/Layout/Stacked';
import TooltipIcon from 'components/Tooltip/TooltipIcon';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {EmployeeRightsCreateBackendData} from '../types';

const OtherOptions = () => {
    const {
        appPermissions: {canEditRights},
    } = useBackend<EmployeeRightsCreateBackendData>();

    return (
        <div className="mb-8">
            <Accordion className="mb-4" header={t`Other`} id="other">
                <Stacked>
                    <Checkbox
                        helpText={t`Enabling Time Tracking automatically grants the Timesheet Create/Edit/Delete rights, as well as the Timesheet Cancel right.`}
                        label={
                            <span className="flex gap-2 items-center">
                                {t`Time Tracking`}
                                <TooltipIcon
                                    href="https://help.makeleaps.jp/ja/articles/3941662-作業時間を管理する"
                                    message={t`What is Time Tracking?`}
                                    size="base"
                                />
                            </span>
                        }
                        name="time_tracking"
                        readOnly={!canEditRights.allowed}
                    />
                    <Checkbox
                        helpText={t`MakeLeaps “Sales management” feature means the ability to create/convert documents, send by email or post, and mark as sent or paid anytime.`}
                        label={t`Sales Management`}
                        name="sales_mgmt_license"
                        readOnly={!canEditRights.allowed}
                    />
                </Stacked>
            </Accordion>
        </div>
    );
};

export default OtherOptions;
